import * as React from 'react'
import type {IBaseLayoutProps} from '~/layouts/BaseLayout'
import BaseLayout from '~/layouts/BaseLayout'
import {HeaderWordmark} from '~/layouts/components/HeaderWordmark'
import styles from './styles.module.css'

interface IProps extends IBaseLayoutProps {
  children: React.ReactNode
}

export default class FEMLayout extends React.Component<IProps> {
  render() {
    return (
      <BaseLayout {...this.props}>
        <div className={styles.topBar}>
          <div className={styles.left}>
            <HeaderWordmark />
          </div>
        </div>
        <div className={styles.femLayoutFrame}>{this.props.children}</div>
      </BaseLayout>
    )
  }
}
